export default {"src":"/_next/static/media/role-parents.e943f62d.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};